import { render, staticRenderFns } from "./membershipAdd.vue?vue&type=template&id=b1a10440&scoped=true"
import script from "./membershipAdd.vue?vue&type=script&lang=js"
export * from "./membershipAdd.vue?vue&type=script&lang=js"
import style0 from "./membershipAdd.vue?vue&type=style&index=0&id=b1a10440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a10440",
  null
  
)

export default component.exports